import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';
import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreLoadingComponent, MapfreModalComponent, MapfreButtonComponent],
  selector: 'app-autopay-payment-method-modal',
  templateUrl: './autopay-payment-method-modal.component.html',
  styleUrls: ['./autopay-payment-method-modal.component.css'],
})
export class AutopayPaymentMethodModalComponent implements OnInit {
    @Input() policy: any;
    @Output() enrollEvent: EventEmitter<string> = new EventEmitter();
    enrollEditModalOptions: ModalOptions;
    modalIcon: string;
    hideModal: boolean;
    isAcmic: boolean;
    loading = false;
  
    constructor(
      private acmicService: AcmicService,
      private dataLayer: DataLayerService
    ) {}
  
    ngOnInit(): void {
      console.log("Enroll tw policy modal :: policy : ", this.policy)
      this.isAcmic = this.acmicService.isACMIC();
  
      this.enrollEditModalOptions = new ModalOptions({
        additionalClasses:
          'autopay-modal upload-document-modal modal-medium modal-dialog modal-center-on-page',
        additionalButtonClasses:
          'basic primary x-small-btn manage-ap-btn enroll-ap-btn',
        animatePosition: 'center',
        buttonCopy: 'ENROLL',
        modalId: 'enEnrollModal',
        typeOfModal: 'default',
        modalName: 'autopay_enroll',
      });
  
      this.modalIcon = this.isAcmic 
                          ? './assets/img/images/unenroll-modal-acmic.svg'
                          : './assets/img/images/unenroll-modal-ma.svg';
    }
  
    resetHideModal(): void {
      this.hideModal = !this.hideModal;
    }
  
    hideModalAction(event): void {
      if (event) {
        this.hideModal = !this.hideModal;
      }
    }
  
    onCheckingSavingAccountClick(){
      if(this.policy?.company?.companyName === 'TW'){
         this.dataLayer.pushManagePolicyEvent('Enroll with checking/savings')
      }
        this.enrollEvent.emit('ENROLL');
    }

    onCreditDebitCardClick(){
      if(this.policy?.company?.companyName === 'TW'){
         this.dataLayer.pushManagePolicyEvent('Enroll with credit/debit card')
      }
      this.enrollEvent.emit('ENROLL CREDIT-DEBIT-CARD');
    }

    onOpenModal(){
      if(this.policy?.company?.companyName === 'TW'){
         this.dataLayer.pushManagePolicyEvent('Enroll in autopay')
      }
    }
}
